import React, { useEffect, useRef, useState } from 'react'
import PropTypes from 'prop-types'

import DeleteIcon from '@mui/icons-material/Delete'

import { StyledDialog, FlexEndContainer, FlexDialogContent } from '../styles/Containers'
import Button, { IconButton, SecondaryButton } from '../common/Button'
import BodyText from '../styles/Text'
import axios from '../../dataClient/dataClient'
import { ErrorMessage } from '../common/UserMessage'

function DeleteFileButton({ fileId, onDelete = () => {}, disabled = false }) {
  const [isVisible, setIsVisible] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState(false)

  const handleOpen = () => setIsVisible(true)
  const handleClose = () => {
    setError(false)
    setIsVisible(false)
    setIsLoading(false)
  }

  const isMounted = useRef(true)

  useEffect(() => {
    return () => {
      isMounted.current = false
    }
  }, [])

  function handleDelete() {
    setIsLoading(true)

    axios
      .delete(`/file/${fileId}`)
      .then(() => {
        onDelete(fileId)
        handleClose()
      })
      .catch(e => {
        setIsLoading(false)
        setError(true)
        console.error('failed to delete file', fileId, e)
      })
  }

  return (
    <div>
      <IconButton color="secondary" onClick={handleOpen} aria-label="Delete file" disabled={disabled}>
        <DeleteIcon />
      </IconButton>
      <StyledDialog fullWidth open={isVisible} onClose={handleClose} keepMounted={false}>
        <FlexDialogContent>
          <BodyText>Are you sure you want to delete this file?</BodyText>
          {error && <ErrorMessage />}
          <FlexEndContainer>
            <SecondaryButton onClick={handleClose} disabled={isLoading}>
              Cancel
            </SecondaryButton>
            <Button onClick={handleDelete} loading={isLoading}>
              Delete
            </Button>
          </FlexEndContainer>
        </FlexDialogContent>
      </StyledDialog>
    </div>
  )
}

DeleteFileButton.propTypes = {
  fileId: PropTypes.string.isRequired,
  onDelete: PropTypes.func,
  disabled: PropTypes.bool
}

export default DeleteFileButton
